import {
  apiGetCursorPage,
  type ApiRequestOptions,
} from "@softmax/observatory-client/client";
import { ApiError } from "@softmax/observatory-client/transport";
import { limitPublicRead } from "@softmax/web-features/data/public-api";
import type { LeagueSubmissionPublic } from "../../desk-records";
import { entryPageSize, type PitchCursor } from "../pagination";

export function readPitchSubmissions({
  leagueId,
  cursor,
  options,
}: {
  readonly leagueId: string;
  readonly cursor: PitchCursor | null;
  readonly options: ApiRequestOptions;
}): ReturnType<typeof apiGetCursorPage<LeagueSubmissionPublic>> {
  const params = new URLSearchParams({
    league_id: leagueId,
    limit: String(entryPageSize),
  });

  if (cursor?.submissions) params.set("cursor", cursor.submissions);

  return !cursor || cursor.submissions
    ? limitPublicRead(() =>
        apiGetCursorPage<LeagueSubmissionPublic>(
          `/v2/league-submissions?${params}`,
          options,
        ),
      ).catch((error: unknown) => {
        if (error instanceof ApiError && error.status === 401)
          return { entries: [], next_cursor: null };

        throw error;
      })
    : Promise.resolve({ entries: [], next_cursor: null });
}
